import Layout from './Layout';
import HomePage from './pages/HomePage';
import CompanyDetail from './pages/CompanyDetail';
import CompanyListing from './pages/CompanyListing';
import FavoriteListing from './pages/FavoriteListing';
import SmallCase from './pages/SmallCase';
import CompanyOldDetail from './pages/CompanyOldDetail';
import VideosPage from './pages/VideosPage';

export default{
  HomePage,
  CompanyOldDetail,
  SmallCase,
  VideosPage,
  CompanyDetail,
  Layout,
  CompanyListing,
  FavoriteListing,
}